import type { DriveStep } from 'driver.js';

const at = (id: string) => `[data-tour="${id}"]`;

/** "Tour this page" for AI Marketer (/ai-marketer). Anchors live in AiMarketerPage.tsx. */
export function getAiMarketerTourSteps(): DriveStep[] {
  return [
    {
      popover: {
        title: 'Your AI Marketer',
        description:
          'Your AI Marketer works your farm for you: home valuations that capture sellers, a hot ' +
          'list of people likely to buy or sell, and a monthly email that keeps you in front of ' +
          'homeowners.',
      },
    },
    {
      element: at('marketer-tabs'),
      popover: {
        title: 'Four rooms',
        description:
          'Today: Dough, your daily number, who to call and your progress. ' +
          'Find sellers: home values people asked for, your hot list, people you know and your farm. ' +
          'Find buyers: your registration wall, just-sold campaigns and direct mail. ' +
          'Get known: a monthly community newsletter, local business spotlights and ads.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: at('marketer-coach'),
      popover: {
        title: 'Dough, your daily coach',
        description:
          'Tell Dough what you want to earn and how much time and money you have. Dough works it ' +
          'back to how many people to talk to each day, and lists who to reach today. Each Done fills ' +
          'the ring, earns points and keeps your streak going.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: at('marketer-switch'),
      popover: {
        title: 'Turn it on or off',
        description:
          'This starts and pauses your Marketer’s own work, like just-sold pages, newsletter ' +
          'drafts, community stats and referral spotting. Emails people asked for, like saved-search ' +
          'alerts and their monthly home value, keep going either way.',
        side: 'bottom',
        align: 'end',
      },
    },
    {
      element: at('marketer-stats'),
      popover: {
        title: 'Your numbers',
        description:
          'Valuations in the last 30 days, open hot leads, open new leads, and how many people ' +
          'subscribe to your value reports.',
        side: 'top',
        align: 'center',
      },
    },
    {
      element: at('marketer-persona'),
      popover: {
        title: 'Your Marketer',
        description:
          'Give Dough a tone and a sign-off, and choose for each kind of work whether it only ' +
          'drafts, asks you first, or publishes on its own. Just above are your pipeline and ' +
          'listing kits: draft descriptions and posts for your own office’s listings, ready for ' +
          'you to review and copy.',
        side: 'top',
        align: 'start',
      },
    },
  ];
}
